const l = {unitSelectors: '[data-unit-selector]', unitValues: '[data-unit-value]'};
class o extends HTMLElement {
  constructor() {
    super(), (this.settings = {title: '', values: '', enableUnitConversion: !1, hideFirstTableHeader: !0});
  }
  connectedCallback() {
    const e = JSON.parse(this.getAttribute('data-settings'));
    (this.settings.title = e.title || ''),
      (this.settings.values = e.table || ''),
      (this.settings.enableUnitConversion = e.enable_unit_conversion || !1),
      (this.settings.hideFirstTableHeader = e.hide_first_table_header || !1),
      this.buildTable(),
      setTimeout(() => {
        this.initUnitSelectors();
      }, 50);
  }
  buildTable() {
    const e = this.convertCsvToArrays();
    if (!e.length) return;
    const t = document.createElement('div');
    (t.innerHTML = `
      ${this.createTableWrapperHeader()}

      <div class="component-size-table__table-wrapper">
        <table class="component-size-table__table">
          ${this.createTableHeader(e[0])}
          ${this.createTableBody(e.slice(1))}
        </table>
      </div>
    `),
      this.appendChild(t);
  }
  createTableWrapperHeader() {
    if (!this.settings.enableUnitConversion && !this.settings.title) return '';
    const e = this.settings.title.toLowerCase().replace(/\s+/g, '-');
    let t = '';
    return (
      this.settings.title && (t += `<h3>${this.settings.title}:</h3>`),
      this.settings.enableUnitConversion &&
        (t += `
      <div class="component-size-table__unit-conversion">
        <input
          type="radio"
          value="cm"
          name="conversion[${e}][unit]"
          id="${e}_unit_cm"
          data-unit-selector="cm"
          checked
        >
        <label for="${e}_unit_cm">CM</label>

        <input
          type="radio"
          value="in"
          name="conversion[${e}][unit]"
          id="${e}_unit_in"
          data-unit-selector="in"
        >
        <label for="${e}_unit_in">IN</label>
      </div>
      `),
      `<div class="component-size-table__header">${t}</div>`
    );
  }
  createTableHeader(e) {
    return `
      <thead>
        <tr>
        ${e.map((t, i) => (this.settings.hideFirstTableHeader && i === 0 ? `<th><span class="visually-hidden">${t}</span></th>` : `<th>${t}</th>`)).join('')}
        </tr>
      </thead>
    `;
  }
  createTableBody(e) {
    const t = (n) => {
        if (typeof n != 'number' || !this.settings.enableUnitConversion) return n;
        const r = n;
        let a = (n * 0.393701).toFixed(1);
        return (
          a.endsWith('.0') && (a = a.slice(0, -2)),
          `
        <span data-unit-value="cm" aria-label="${r} cm">${r}</span>
        <span data-unit-value="in" aria-label="${a} in" aria-hidden="true">${a}</span>
      `
        );
      },
      i = (n, r) => (r === 0 ? `<th>${n}</th>` : `<td>${t(n)}</td>`),
      s = (n) => `
        <tr>
          ${n.map((r, a) => i(r, a)).join('')}
        </tr>
      `;
    return `
      <tbody>
        ${e.map((n) => s(n)).join('')}
      </tbody>
    `;
  }
  convertCsvToArrays() {
    return this.settings.values
      ? this.settings.values
          .replaceAll(', ', ',')
          .split(
            `
`
          )
          .map((t) =>
            t.split(',').map((i) => {
              const s = Number(i);
              return s || i;
            })
          )
      : [];
  }
  initUnitSelectors() {
    const e = this.querySelectorAll(l.unitSelectors);
    e.length &&
      (e == null ||
        e.forEach((t) => {
          t.addEventListener('change', this.handleUnitChange.bind(this));
        }));
  }
  handleUnitChange(e) {
    const t = this.querySelectorAll(l.unitValues),
      i = e.target.value;
    i &&
      (t == null ||
        t.forEach((s) => {
          s.setAttribute('aria-hidden', i !== s.getAttribute('data-unit-value'));
        }));
  }
}
function u() {
  customElements.define('component-size-table', o);
}
export {u as i};
